import { get } from '.';
import qs from 'qs';

export const getBedTypes = ({ filters }) => {
  return get(`/beds?${qs.stringify(filters)}`);
};
